import {useTranslation} from 'react-i18next';
import {TriangleAlertIcon, CheckIcon} from 'lucide-react';
import cn from 'clsx';

type props = {
  completed: boolean;
  className?: string;
  texts?: {
    completed?: string;
    incomplete?: string;
  };
};

function StatusText({completed, className, texts}: props) {
  const {t} = useTranslation();

  const completedText = texts?.completed || t('completed');
  const incompleteText = texts?.incomplete || t('incomplete');
  const statusText = completed ? completedText : incompleteText;

  return (
    <>
      <div
        className={cn(
          'flex items-center w-full  font-bold text-sm leading-6 nav-item__status',
          !completed ? 'text-[var(--status-warning)]' : 'text-[var(--status-success)]',
          className,
        )}
      >
        {completed ? (
          <CheckIcon
            size={16}
            className="mr-1 nav-item__check-icon"
            data-testid="status-icon"
          />
        ) : (
          <TriangleAlertIcon
            size={16}
            className="mr-1 
              [&>*:first-child]:fill-current
              [&>*:first-child]:stroke-transparent
              [&>*:not(:first-child)]:stroke-white nav-item__warning-icon"
            data-testid="status-icon"
          />
        )}
        {statusText}
      </div>
    </>
  );
}

export {StatusText};
